/**
 * Calculation operator values
 */
export enum CalculationOperatorEnum {
	EQUAL = 'equal',
	NOT_EQUAL = 'not_equal',
	GREATER_THAN = 'greater_than',
	GREATER_THAN_OR_EQUAL = 'greater_than_or_equal',
	LESS_THAN = 'less_than',
	LESS_THAN_OR_EQUAL = 'less_than_or_equal',
	IN = 'in',
	NOT_IN = 'not_in',
}
